import baseProps from "../../../input/baseProps.js";

const baseCustomerTypeAheadProps = {
  ...baseProps,
};

delete baseCustomerTypeAheadProps.value;

export default baseCustomerTypeAheadProps;
